module.exports = __webpack_public_path__ + "img/icon-seal-num.17111e3d.png";